import { Button, Result } from 'antd';
import { Navigate, Outlet, useNavigate } from 'react-router';
import { ROUTES } from '@/constants';
import { isAdminInGlobalView } from '@/services/auth';
import { IMPERSONATION_REQUIRED_MESSAGE } from '@/utils/apiErrorMessage';

/**
 * Wraps the Rental routes. An Admin in Global view has no Rental, so the route
 * cannot work: show how to get one instead of the page. A screen with its own
 * wording for the refusal passes it as `impersonationMessage`.
 */
export const RentalRouteGuard = ({
  impersonationMessage = IMPERSONATION_REQUIRED_MESSAGE,
}: {
  impersonationMessage?: string;
}): React.JSX.Element => {
  const navigate = useNavigate();

  if (isAdminInGlobalView()) {
    return (
      <Result
        status="info"
        title="Rental Selection Required"
        subTitle={impersonationMessage}
        extra={
          <Button
            type="primary"
            onClick={() => {
              void navigate(ROUTES.RENTALS);
            }}
          >
            Go to Rentals
          </Button>
        }
      />
    );
  }

  return <Outlet />;
};

export const HomeRedirect = (): React.JSX.Element => (
  <Navigate to={isAdminInGlobalView() ? ROUTES.RENTALS : ROUTES.DASHBOARD} replace />
);
